import { StateSlice } from '@core/state/state-slice';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IEntitiesState } from './entities-state';

export const selectEntityState = createFeatureSelector<IEntitiesState>(StateSlice.ENTITY);

export const getLocationEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.location
);

export const getDeliveryOrderEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.deliveryOrder
);

export const getDeliveryOrderConfigEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.deliveryOrderConfig
);

export const getDispatchConfigEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.dispatchConfig
);

export const getInvoicesEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.invoice
);

export const getUserEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.user
);

export const getDriverEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.driver
);

export const getApiKeyEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) =>  state.entities.apiKey
);

export const getReportDeliveriesByDriverEntities = createSelector(
    selectEntityState,
    (state: IEntitiesState) => state.entities.reportDeliveriesByDriver
);
